import React from 'react';
import SelectField from '../SelectField';
import COUNTRIES from './countryData';

const countryChoices = Object.entries(COUNTRIES);

const CountryField = props => <SelectField {...props} choices={countryChoices} />;

export default CountryField;
